import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import moneyFormat from 'utils/format/money'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'
import store from 'utils/store/withMiddleware'
import stickySummary from '../components/plan-summary/sticky'
import { Decimal } from 'decimal.js'
import { getExternalPlanTotal, getSelectedLevel } from 'utils/plans/parseExternalBenefits'

/** Opens the flex benefits customization modal for a given external plan */
export function handleOpenFlexBenefitsModal(e) {
  e.preventDefault()
  e.stopPropagation()
  e.stopImmediatePropagation()
  const planId = this.getAttribute('data-plan-id')
  const state = store.getState()
  const plan = state.externalPlans?.find((p: any) => String(p.id) === planId)
  if (!plan) return

  const selectedLevels = state.selectedBenefitLevels?.[planId] || {}
  const benefits = plan.products
    .flatMap((p: any) => p.benefits || [])
    .map((benefit: any) => {
      const selectedLevel = getSelectedLevel(benefit, selectedLevels)
      const levels = (benefit.levels || []).map((l: any) => ({
        ...l,
        isCurrentlySelected: l.id === selectedLevel?.id
      }))
      return {
        ...benefit,
        levels,
        selectedLimitation: selectedLevel?.limitation || '',
        selectedPrice: selectedLevel?.price || 0
      }
    })

  const totalAmount = getExternalPlanTotal(plan, selectedLevels)

  const templateModal = Templater(getById('template-flex-benefits-modal').innerText)
  innerHTML(
    '#addOnModal .modal-body',
    templateModal(
      { planId, planName: plan.name, benefits, totalAmount },
      { asMoney: moneyFormat }
    )
  )
  ;($('#addOnModal') as any).modal('show')
}

/** Updates total and limitation text in real-time as dropdowns change inside the modal */
export function handleFlexBenefitLevelPreview(e) {
  const modal = document.getElementById('addOnModal')
  if (!modal) return

  // Update limitation text for the changed select
  const changedSelect = e.target as HTMLSelectElement
  if (changedSelect) {
    const opt = changedSelect.options[changedSelect.selectedIndex]
    const limitation = opt?.getAttribute('data-limitation') || ''
    const benefitWrapper = changedSelect.closest('.flex-benefits-modal__benefit')
    const limitationEl = benefitWrapper?.querySelector('.js-flex-benefit-limitation')
    if (limitationEl) limitationEl.textContent = limitation
  }

  // Recompute total from all selects
  const selects = modal.querySelectorAll<HTMLSelectElement>(
    '.js-flex-benefit-level-select'
  )
  let total = new Decimal(0)
  selects.forEach(sel => {
    const opt = sel.options[sel.selectedIndex]
    total = total.plus(new Decimal(opt?.getAttribute('data-price') || '0'))
  })
  const totalEl = modal.querySelector('.js-flex-benefits-modal-total')
  if (totalEl) totalEl.textContent = moneyFormat(total.toNumber())
}

/** Persists selected benefit levels and triggers price/description re-render */
export function handleApplyFlexBenefitLevels() {
  const planId = this.getAttribute('data-plan-id')
  const modal = document.getElementById('addOnModal')
  if (!modal || !planId) return

  const selects = modal.querySelectorAll<HTMLSelectElement>(
    '.js-flex-benefit-level-select'
  )
  const levelSelections: Record<string, string> = {}
  selects.forEach(sel => {
    const benefitId = sel.getAttribute('data-benefit-id')
    if (benefitId) levelSelections[benefitId] = sel.value
  })

  const state = store.getState()
  const selectedBenefitLevels = {
    ...(state.selectedBenefitLevels || {}),
    [planId]: levelSelections
  }
  store.update({ selectedBenefitLevels })
  ;($('#addOnModal') as any).modal('hide')
  stickySummary()
}
